<div class="user-dropdown-menu">
  <div nz-dropdown nzTrigger="click" class="dropdown" [nzDropdownMenu]="menu">
    <span class="menu-icon-fs">
      <i class="fa fa-ellipsis-h"></i>
    </span>
  </div>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="user-dropdown-menu-list">
      <ul nz-menu>
        <li nz-menu-item class="font-size-14 text-center">
          <strong class="w-100 text-center">
            {{ 'topBar.profileMenu.hello' | translate }}, {{ name }} {{ surname }}
          </strong>
        </li>

        <li nz-menu-divider></li>

        <li nz-menu-item class="font-size-14">
          <table class="table table-borderless mb-0">
            <tr>
              <td class="pt-2 pb-1">{{ 'topBar.profileMenu.role' | translate }}:</td>
              <td class="pt-2 pb-1 fw-bold">{{ group }}</td>
            </tr>
            <tr>
              <td class="pt-2 pb-1">{{ 'topBar.profileMenu.company' | translate }}:</td>
              <td class="pt-2 pb-1 fw-bold">{{ systemInfo?.Company_Name }}</td>
            </tr>
            <tr>
              <td class="pt-2 pb-1">{{ 'topBar.profileMenu.installation' | translate }}:</td>
              <td class="pt-2 pb-1 fw-bold">{{ systemInfo?.Plant_Name }}</td>
            </tr>
          </table>
        </li>

        <li nz-menu-divider></li>

        <li nz-menu-item class="font-size-12 d-block" style="min-height: 100px">
          <ng-container *ngIf="versioning">
            <table class="table table-borderless mb-0">
              <tr>
                <td class="pt-1 pb-1">{{ 'topBar.app.version' | translate }}:</td>
                <td class="pt-1 pb-1 fw-bold">{{ versioning?.release }}</td>
              </tr>
              <tr>
                <td class="pt-1 pb-1">Frontend:</td>
                <td class="pt-1 pb-1 fw-bold">{{ versioning?.frontend?.no }}.{{ versioning?.frontend?.source }}</td>
              </tr>
              <tr>
                <td class="pt-1 pb-1">Backend:</td>
                <td class="pt-1 pb-1 fw-bold">{{ versioning?.backend?.no }}.{{ versioning?.backend?.source }}</td>
              </tr>
              <tr>
                <td class="pt-1 pb-1">Database:</td>
                <td class="pt-1 pb-1 fw-bold">{{ versioning?.database?.no }}.{{ versioning?.database?.source }}</td>
              </tr>
            </table>
          </ng-container>
          <ng-container *ngIf="modules.length > 0">
            <div class="mt-3">
              {{ 'topBar.app.installed.modules' | translate }}:
            </div>
            <ul>
              <li *ngFor="let module of modules">
                {{ module['label'] }}
              </li>
            </ul>
          </ng-container>
        </li>

        <li nz-menu-divider></li>

        <ng-container *ngIf="hasExcel() || hasPdf()">
          <li class="ant-dropdown-menu-item font-size-12 d-block pt-0 pb-0">
            <table class="table table-borderless m-0 p-0">
              <tr>
                <td class="text-center pt-1 pb-1">
                  <div class="mb-1">
                    {{ 'topBar.export.options.excel' | translate }}
                  </div>
                  <button type="button" class="btn btn-downloadable me-2 ms-2" (click)="downloadExcel()" [disabled]="!hasExcel()" title="Excel">
                    <i class="far fa-file-excel"></i>
                  </button>
                </td>
                <td class="text-center pt-1 pb-1">
                  <div class="mb-1">
                    {{ 'topBar.export.options.pdf' | translate }}
                  </div>
                  <button type="button" class="btn btn-downloadable me-2 ms-2" (click)="downloadPdf()" [disabled]="!hasPdf()" title="PDF">
                    <i class="far fa-file-pdf"></i>
                  </button>
                </td>
              </tr>
            </table>
          </li>

          <li nz-menu-divider></li>
        </ng-container>

        <li nz-menu-item class="font-size-12 p-0 text-center">
          <a
            href="{{ acrAppURL }}"
            target="_blank"
            class="user-menu-link p-2 w-100"
            title="{{ 'topBar.user.acr' | translate }}">
            <img
              src="./assets/images/logo/acr-logo.svg"
              alt="{{ 'topBar.user.acr' | translate }}"
              class="acr-logo">
          </a>
        </li>

        <li nz-menu-divider></li>

        <ng-container *ngIf="hasManual()">
          <li nz-menu-item class="font-size-12 p-0 text-center">
            <a title="{{ 'topBar.user.manual' | translate }}"
               class="user-menu-link p-2 w-100"
               (click)="downloadManual()">
              {{ 'topBar.user.manual' | translate }}
            </a>
          </li>

          <li nz-menu-divider></li>
        </ng-container>

        <li nz-menu-item class="font-size-12 p-0 text-center">
          <a [routerLink]="['/spas/third-party-license-notes']"
             title="{{ 'topBar.third.party.license' | translate }}"
             target="_blank"
             class="user-menu-link p-2 w-100">
            {{ 'topBar.third.party.license' | translate }}
          </a>
        </li>

        <li nz-menu-divider></li>

        <li nz-menu-item class="font-size-12 p-0 text-center">
          <a [routerLink]="['/spas/cookie-policy']"
             title="{{ 'topBar.cookie.policy' | translate }}"
             target="_blank"
             class="user-menu-link p-2 w-100">
            {{ 'topBar.cookie.policy' | translate }}
          </a>
        </li>

        <li nz-menu-divider></li>

        <li nz-menu-item class="font-size-14 p-0 text-center">
          <a (click)="logout()"
             class="user-logout-button p-2 w-100"
             title="{{ 'topBar.profileMenu.logout' | translate }}">
            <i class="fa fa-sign-out-alt me-1 text-danger"></i>
            <span class="font-size-12">{{ 'topBar.profileMenu.logout' | translate }}</span>
          </a>
        </li>
      </ul>
    </div>
  </nz-dropdown-menu>
</div>
